//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "index",
  computed: {
    availableLocales() {
      return this.$i18n.locales;
    }
  }
}

